import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "page-background_header flex-row align-center justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "no-title"
}
const _hoisted_3 = {
  key: 1,
  class: "page-background_header-title flex-row align-center"
}
const _hoisted_4 = { class: "ion-text-center title-size mr-5 ml-5" }
const _hoisted_5 = {
  key: 2,
  class: "right-bar"
}
const _hoisted_6 = { class: "right-bar_content" }

import { onMounted, ref } from "vue"
import { useRouter } from "vue-router"
import { useDebounceFn, useScroll } from "@vueuse/core"

interface PropsData {
  title: string
  routerType?: "modal" | "router"
  hasTitle?: string
  backgroundColor?: Record<string, any>
  hasModeSwitch?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonBackground',
  props: {
    title: {},
    routerType: {},
    hasTitle: {},
    backgroundColor: {},
    hasModeSwitch: { type: Boolean }
  },
  emits: ["routerBack", "queryList"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const router = useRouter()
const emit = __emit
const isLoad = ref(false)
const hasTitle = ref(true)

function routerBack() {
  if (props.routerType === "modal") {
    emit("routerBack")
    return
  }
  router.back()
}

const scrollQueryFn = useDebounceFn(() => {
  emit("queryList")
}, 500)

function scrollEvent(e: any) {
  const { directions } = useScroll(e.target)
  if (directions.bottom) {
    scrollQueryFn()
  }
}

onMounted(() => {
  hasTitle.value = props.hasTitle !== "essayGenerate"
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "page-background flex-column align-center",
    style: _normalizeStyle(props.backgroundColor)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["cursor-pointer page-background_header-back", { 'visibility-hidden': props.title === '学后检测' }]),
        onClick: routerBack
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "iconfont icon-back" }, null, -1),
        _createTextVNode("返回", -1)
      ]))], 2),
      (!hasTitle.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "noTitleContent")
          ]))
        : _createCommentVNode("", true),
      (hasTitle.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(props.title), 1)
          ]))
        : _createCommentVNode("", true),
      (hasTitle.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "rightTitle", {
                style: _normalizeStyle({ cursor: !__props.hasModeSwitch ? 'not-allowed' : 'default' })
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "page-background_content",
      onScroll: scrollEvent
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 32)
  ], 4))
}
}

})